
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/[id]",
      function () {
        return require("private-next-pages/case-studies/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/[id]"])
      });
    }
  